import { useEffect, useState } from 'react';
import ThemeMaker from '../../components/thememaker';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { config } from "../../utils/config";
import axios from 'axios';
import { Paginated } from '../../components/Paginated';
import CircularProgress from '@mui/material/CircularProgress';
import brandStyles from '../Brand/Brand.module.css';
import styles from './Addroducttype.module.css';
import '../../components/mcrbTableTheme.css';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

const Sstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: "16px",
    bgcolor: 'background.paper',
    boxShadow: 'none',
    outline: 'none',
    p: 0,
};

export default function Productlist() {
    const { apiEndpoint } = config;
    const [productTypes, setproductTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
    const [mandatoryAttrModalOpen, setmandatoryAttrModalOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewData, setViewData] = useState<any>(null);
    const [file, setFile] = useState<any>(null);
    const [mafile, setmaFile] = useState(null);
    useEffect(() => {
        getproductTypes()
    }, [])

    async function getproductTypes() {
        try {
            setIsLoading(true)
            const { data } = await axios({
                url: `${apiEndpoint}/getProtypeList`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },

            })
            console.log(data)
            if (data.status === 200) {
                setproductTypes(data?.data)
                setIsLoading(false)
            } else {
                toast.error("Error In Loading Product Type");

            }
        } catch (err) {
            setIsLoading(false)
            toast.error("Error in Getting Product Types")
        }
    }
    async function deleteHandler(id: any) {
        try {
            setIsLoading(true)
            const { data } = await axios({
                url: `${apiEndpoint}/deleteprotype`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },
                data: {
                    id
                }

            })

            if (data.status === 200) {
                toast.success("Deleted Successfully");
                setTimeout(() => {
                    getproductTypes()
                }, 1000)
            } else {
                toast.error("Error In Deleting Product Type");

            }
        } catch (err) {
            setIsLoading(false)
            toast.error("Error in API")
        }
    }

    function openViewModal(row: any) {
        setViewData(row);
        setViewModalOpen(true);
    }
    function closeViewModal() {
        setViewModalOpen(false);
    }

    const handleImport = async () => {
        Papa.parse(file, {
            header: true,
            dynamicTyping: true,
            complete: ({ data }) => {
                let abc = data.filter((item: any) => item.name !== null)
                let orders = abc.map((order: any) => ({
                    name: order.name ?? "",
                    ondc_mapping: order.ondc_mapping ?? "",
                    product_category_name: order.product_category_name ?? ""
                }))
                let jsonData = {
                    product_types: orders
                };
                sendDataToDb(jsonData)
            },
        });
    };

    const handleMAFileChange = (event: any) => {
        const selectedFile = event.target.files[0];
        if (selectedFile && selectedFile.type === "text/csv") {
            setmaFile(selectedFile);
        } else {
            alert("Please select a valid CSV file.");
        }
    };

    const handleMAImport = async () => {
        const formData: any = new FormData();
        formData.append("file", mafile);
        await axios({
            url: `${apiEndpoint}/import_mandate_attribute`,
            method: 'POST',
            headers: {
                "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                "Content-Type": "multipart/form-data"
            },
            data: formData
        })
        toast.success("Imported Successfully!");
        setmandatoryAttrModalOpen(false)
    };

    async function sendDataToDb(jsonData: any) {
        try {
            let result = await axios({
                url: `${apiEndpoint}/addProductTypeCsv`,
                method: 'POST',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },
                data: jsonData,
            })

            if (result.status === 200) {
                toast.success("Product Types added successfully !");
                setFile(null)
                let inputelement: any = document.getElementById('inputFile');
                if (inputelement) inputelement.value = ''
                getproductTypes()
            } else {
                toast.error("403 error !");
            }
        } catch (error) {
            toast.error("403 error !");
        }
    }

    function handleShipementModalClose() {
        setshipmentModalOpen(false)
    }
    function handleMAModalClose() {
        setmandatoryAttrModalOpen(false)
    }

    async function getSampleCsv() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/download_product_type_csv`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            })
            if (data && (data.status === 200 || data.status === "200" || Number(data.status) === 200)) {
                const headers = Object.keys(data?.data[0]);
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(data?.data, { header: headers });
                XLSX.utils.book_append_sheet(wb, ws, 'Orders');
                const fileName = `Sample_Product_Type_${new Date().getTime()}.csv`;
                XLSX.writeFile(wb, fileName);
            }
        } catch (err) {
            toast.error("Server not working, please try later!")
        }
    }

    const COLUMNS = [
        
        {
            Header: "Name",
            Footer: "Name",
            accessor: (row: any) => <span style={{ color: "#1F2430", fontWeight: 700, fontFamily: "'Sora', 'Inter', sans-serif" }}>{row.name}</span>,
            sticky: "left"
        },
        {
            Header: "ONDC Mapping",
            Footer: "ONDC Mapping",
            accessor: (row: any) => (
                <span
                    title={row.ondc_mapping}
                    style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        maxWidth: "280px",
                        whiteSpace: "normal",
                        overflowWrap: "anywhere",
                        fontSize: "13px",
                    }}
                >
                    {row.ondc_mapping}
                </span>
            ),
            sticky: "Status"
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: (row: any) => (
                <span className={row.status === true ? brandStyles.statusBadgeActive : brandStyles.statusBadgeInactive}>
                    {row.status === true ? "Active" : "Inactive"}
                </span>
            ),
            sticky: "Status"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                        <span className={brandStyles.iconBtn} onClick={() => openViewModal(row)}>
                            <VisibilityOutlinedIcon style={{ color: "#4c2fb3" }} titleAccess="View" />
                        </span>
                        <Link to={`/producttype/${row.id}`} className={brandStyles.iconBtn}>
                            <EditNoteRoundedIcon style={{ color: "#4c2fb3" }} titleAccess="Update" />
                        </Link>
                        <span className={brandStyles.iconBtn} onClick={() => deleteHandler(row.id)}>
                            <DeleteIcon style={{ color: "#EF4444", fontSize: 20 }} titleAccess="Delete" />
                        </span>
                    </div>
                )
            },
            sticky: "left"
        },



    ];


    return (
        <ThemeMaker>
            <div className={`${brandStyles.pageWrap} mcrb-page`}>
                <div className={`${brandStyles.cardOuter} mcrb-card`}>
                    <div className={brandStyles.headerBar}>
                        <span className={brandStyles.title}>Product Type List</span>

                        <div className={styles.headerActions}>
                            <button className={styles.secondaryBtn} onClick={() => setmandatoryAttrModalOpen(true)}>
                                Import Mandatory Attributes
                            </button>

                            <button className={styles.secondaryBtn} onClick={() => setshipmentModalOpen(true)}>
                                Import
                            </button>

                            <Link to="/producttype">
                                <button className={brandStyles.primaryBtn}>Add Product Type</button>
                            </Link>
                        </div>
                    </div>

                    <div className={`${brandStyles.bodyArea} ${brandStyles.tableWrap}`} style={{ minHeight: "70vh" }}>

                        {!isLoading ? <Paginated data={productTypes} columns={COLUMNS} /> : <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress /></div>}
                    </div>
                </div>
            </div>

            <Modal
                open={shipmentModalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={Sstyle} className={`col-md-4 w-100 w-md-25 ${styles.modalBox}`}>

                    <div className={styles.modalHeader}>
                        <p className={styles.modalTitle}>Import Using Excel File..
                            <span className={styles.downloadLink} onClick={getSampleCsv}>Download Sample CSV</span></p>
                        <span className={styles.modalClose}><CloseIcon onClick={handleShipementModalClose} /></span>
                    </div>
                    <div className={styles.modalBody}>
                        <input type="file" id="inputFile" className={styles.modalFileInput} onChange={(e: any) => {
                            setFile(e.target.files[0]);
                        }} />
                    </div>
                    <div className={styles.modalFooter}>
                        <button className={styles.modalSubmitBtn} onClick={handleImport} > Submit </button>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={mandatoryAttrModalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={Sstyle} className={`col-md-4 w-100 w-md-25 ${styles.modalBox}`}>

                    <div className={styles.modalHeader}>
                        <p className={styles.modalTitle}>Import Using CSV File..</p>
                        <span className={styles.modalClose}><CloseIcon onClick={handleMAModalClose} /></span>
                    </div>
                    <div className={styles.modalBody}>
                        <input type="file" id="inputFile" className={styles.modalFileInput} onChange={(e: any) => {
                            handleMAFileChange(e)
                        }} />
                    </div>
                    <div className={styles.modalFooter}>
                        <button className={styles.modalSubmitBtn} onClick={handleMAImport} > Submit </button>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={viewModalOpen}
                onClose={closeViewModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={Sstyle} className={`col-md-4 w-100 w-md-25 ${styles.modalBox}`}>

                    <div className={styles.modalHeader}>
                        <p className={styles.modalTitle}>Product Type Details</p>
                        <span className={styles.modalClose}><CloseIcon onClick={closeViewModal} /></span>
                    </div>
                    <div className={styles.modalBody}>
                        <div style={{ marginBottom: 14 }}>
                            <div style={{ fontSize: 11.5, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 4 }}>Name</div>
                            <div style={{ fontSize: 14, fontWeight: 700, color: "#1F2430" }}>{viewData?.name}</div>
                        </div>
                        <div style={{ marginBottom: 14 }}>
                            <div style={{ fontSize: 11.5, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 4 }}>ONDC Mapping</div>
                            <div style={{ fontSize: 13.5, color: "#1F2430", wordBreak: "break-word" }}>{viewData?.ondc_mapping || "—"}</div>
                        </div>
                        <div>
                            <div style={{ fontSize: 11.5, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 4 }}>Status</div>
                            <span className={viewData?.status === true ? brandStyles.statusBadgeActive : brandStyles.statusBadgeInactive}>
                                {viewData?.status === true ? "Active" : "Inactive"}
                            </span>
                        </div>
                    </div>
                </Box>
            </Modal>

        </ThemeMaker >
    )
}
